// extracted by mini-css-extract-plugin
export default {"login":"Login_login__45xcb","title":"Login_title__RsIHH","desc":"Login_desc__1y4Qo"};